import {
  CityWithActiveStationModel,
  StateModel,
} from '../models/cities-stations-active';

export class CitiesWithActiveStationsAdapter {
  static fromApi(response: any): CityWithActiveStationModel[] {
    const dataArray = response.data || response;

    if (!Array.isArray(dataArray)) {
      return [];
    }

    return dataArray.map((item: any) => this.mapCity(item));
  }

  private static mapCity(data: any): CityWithActiveStationModel {
    return {
      id: data.id,
      name: data.name,
      ibgeCode: data.ibgeCode,
      state: this.mapState(data.state),
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }

  private static mapState(data: any): StateModel {
    return {
      id: data.id,
      name: data.name,
      code: data.code,
      creationDate: data.creationDate,
      updateDate: data.updateDate,
      userNameCreate: data.userNameCreate,
      userNameUpdate: data.userNameUpdate,
    };
  }
}
